import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { LazyComponentId } from 'src/app/core/services/lazy-components/lazy-components-registry';
import { updateCloseModal, updateOpenModal } from 'src/app/store/common/common.actions';
import { Data } from 'src/app/utils/models/data.interface';

import { ModalResponseData } from './modal-response-data.interface';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private readonly responseDataSubject = new Subject<ModalResponseData>();
  private readonly lazyComponentSubject = new BehaviorSubject<[LazyComponentId | null, Data | null]>([null, null]);

  public constructor(private readonly store: Store) {}

  public get lazyComponent$(): Observable<[LazyComponentId | null, Data | null]> {
    return this.lazyComponentSubject.asObservable();
  }

  public get responseData$(): Observable<ModalResponseData> {
    return this.responseDataSubject.asObservable();
  }

  public open(componentId: LazyComponentId, data: Data = {}): void {
    this.lazyComponentSubject.next([componentId, data]);
    this.store.dispatch(updateOpenModal());
  }

  public close(confirmed = false, data: Data = {}): void {
    this.responseDataSubject.next({ confirmed, data });
    this.lazyComponentSubject.next([null, null]);
    this.store.dispatch(updateCloseModal());
  }
}
